import http from '@/services/http';

const config = {
  getConfig(where) {
    return http.request({
      method: 'get',
      url: '/system-configuration',
      params: { where },
    });
  },
  updateConfig(data) {
    return http.request({
      method: 'patch',
      url: '/system-configuration',
      data,
    });
  },
  getLocationAssignmentStrategy() {
    return http.request({
      method: 'get',
      url: '/location-assignment-strategy',
    });
  },
  patchLocationAssignmentStrategy(assignmentStrategy) {
    return http.request({
      method: 'patch',
      url: '/location-assignment-strategy',
      data: {
        'locations.assignmentStrategy': assignmentStrategy,
      },
    });
  },
};

export default config;
